import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { Input, Icons } from '@/js/libs/ui/src/V2';
export const AUTOFOCUS_WITHOUT_SCROLL = Object.freeze({ preventScroll: true });
export const Search = ({ onChange, onClear, value, autofocus = true }) => {
    const theme = useTheme();
    const ref = React.useRef(null);
    React.useLayoutEffect(() => {
        if (autofocus) {
            ref.current?.focus({ preventScroll: typeof autofocus === 'object' ? autofocus.preventScroll : false });
        }
    }, [ref, autofocus]);
    return (_jsx(Input, { placeholder: 'Search', icon: value ? (_jsx(Icons.Clear, { filled: true, size: 15, color: theme.colors.grey100_1, onClick: onClear })) : (_jsx(Icons.Search, { size: 15, color: theme.colors.grey100_1 })), onChange: onChange, isActionIcon: !!value, value: value, ref: ref, dataTestId: 'dropdown-search-input' }));
};
